export class StatusModel {
  constructor(public descricao: string, public valor: string) {
  }
}
